import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { ExchangeLoginTokenService } from '../../apis/auth';
import { GetEventListService } from '../../apis/events';
import { setAuthData } from '../../redux/actions/authActions';

export default function AutoLogin() {
  const navigate      = useNavigate();
  const dispatch      = useDispatch();
  const existingToken = useSelector((state) => state.auth.token);
  const [checking, setChecking] = useState(true);
  const [urlInvalid, setUrlInvalid] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token  = params.get('token');

    const setAutoLoginSession = (displayName = '') => {
      sessionStorage.setItem('from_auto_login', '1');
      sessionStorage.setItem('auto_login_name', displayName);
    };

    const goToCreateEvent = (name = '', displayName = '') => {
      setAutoLoginSession(displayName);
      const qs = name ? `?event_name=${encodeURIComponent(name)}` : '';
      navigate(`/app/events/create${qs}`, { replace: true });
    };

    const goToEvent = (id, displayName = '') => {
      setAutoLoginSession(displayName);
      navigate(`/app/events/manage/${id}/overview`, { replace: true });
    };

    if (!token) {
      setUrlInvalid(true);
      setChecking(false);
      return;
    }

    const run = async () => {
      try {
        const res = await ExchangeLoginTokenService(token);

        if (!res.data?.success) {
          setUrlInvalid(true);
          setChecking(false);
          return;
        }

        const { auth_token, event_name, user_details } = res.data;
        dispatch(setAuthData(auth_token, user_details));
        const displayName = user_details?.name || '';

        if (!event_name) {
          goToCreateEvent('', displayName);
          return;
        }

        const listRes = await GetEventListService({ search: event_name });
        const data    = listRes?.data?.event_list?.data ?? [];

        const matched = data.filter(
          (e) => e.event_title?.toLowerCase() === event_name?.toLowerCase()
        );

        if (matched.length === 1) {
          goToEvent(matched[0].id, displayName);
        } else if (matched.length > 1) {
          setAutoLoginSession(displayName);
          navigate('/app/events/select', { replace: true, state: { events: matched } });
        } else {
          goToCreateEvent(event_name, displayName);
        }
      } catch {
        setUrlInvalid(true);
        setChecking(false);
      }
    };

    run();
  }, []); // eslint-disable-line

  if (checking) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (urlInvalid) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '24px' }}>
        <div style={{ width: '100%', maxWidth: 480, background: '#fff', borderRadius: 12, padding: '40px 32px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🔗</div>
          <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700, color: '#1a1a1a' }}>Invalid URL</h2>
          <p style={{ color: '#888', margin: 0, fontSize: 15 }}>This link is invalid or has expired. Please request a new link.</p>
        </div>
      </div>
    );
  }

  return null;
}
